import {DistributionTransferReqRes} from './DistributionTransferReqRes.model';
import {DistributionTableItemResponse} from './DistributionTableItemResponse.model';
import {CalculatePricingTierDistributionResult} from './CalculatePricingTierDistributionResult.model';
import {CovercyBankAccountResponse} from 'src/app/shared/models/CovercyBankAccountResponse.model';
import {ClientDetailsResponse} from 'src/app/account/my-account/model/agentDetailsResponse.model';
import {SignatureListReqRes} from 'src/app/shared/models/SignatureListReqRes.model';
import {UnitBankAccountReqRes} from '../../../../shared/models/gp/UnitBankAccountReqRes.model';
import {UnitTransactionReqRes} from '../../../../shared/models/gp/UnitTransactionReqRes.model';
import {PhoneVerificationReqRes} from '../../../../shared/components/phone-verification-dialog/PhoneVerificationReqRes.model';
import DistributionTransactionOtherType from '../../../../shared/enums/DistributionTransactionOtherType.enum';
import {MetaFileLink} from '../../../../models/metaFileLink.model';

export class DistributionReqRes extends DistributionTableItemResponse {

  public distributionTransfers: DistributionTransferReqRes[];
  public fees: CalculatePricingTierDistributionResult;
  public reasonForTransactionText: string;
  public transactionOtherType: DistributionTransactionOtherType;
  public distributionCovercySourceBankAccount: CovercyBankAccountResponse;
  public distributingEntityId: number;
  public distributingEntity: ClientDetailsResponse;
  public isDeleteAllowed: boolean;
  public isManualCompletionAllowed: boolean;
  public noticePersonalMessage: string;
  public payoutPersonalMessage: string;
  public amountNet: number;
  public amountGross: number;
  public amountAfterTaxes: number;
  public taxes: number;
  public adjustments: number;
  public sendEmail: boolean;

  public signatureList: SignatureListReqRes;

  public unitBankAccountId: number;
  public unitBankAccount: UnitBankAccountReqRes;

  public unitTransactionId: number;
  public unitTransaction: UnitTransactionReqRes;

  public phoneVerificationId: number;
  public phoneVerification: PhoneVerificationReqRes;

  public waterfallMetaFileLinkId: number;
  public waterfallMetaFileLink: MetaFileLink;
}
